module.exports = __webpack_public_path__ + "img/822.a5de0f0e.png";